// apps/web/src/components/audit-logs/AuditLogsViewer.tsx
// Audit trail explorer.

import { ManagerPage } from '../platform/ManagerPage.js';
import type { AuditLog } from '../../types/platform.js';

export function AuditLogsViewer() {
  return (
    <ManagerPage
      title="Audit Logs"
      listPath="/api/v1/audit-logs"
      listKey="logs"
      className="audit-logs-viewer"
      renderItem={(raw) => {
        const l = raw as AuditLog;
        return (
          <div className="manager-card audit-row" key={l.id}>
            <h3>{l.action}</h3>
            <p>
              {l.resourceType ?? '—'} / {l.resourceId?.slice(0, 8) ?? '—'}
            </p>
            <p className="mono">{l.id.slice(0, 12)}…</p>
            <p className="muted">{l.createdAt}</p>
          </div>
        );
      }}
    />
  );
}